module.exports = __webpack_public_path__ + "img/开盒有礼.1575d633.png";